import { muiTheme } from "@/styles/theme";
import { Box, Typography, useTheme } from "@mui/material";
import removeNote from "@/assets/images/note-remove.svg";

const EmptySection = ({ title }: { title: string }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        borderRadius: 2,
        width: "100%",
        backgroundColor: muiTheme.colorSchemes.light.palette.background.white,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "32px",
          height: "32px",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
        component="img"
        src={removeNote}
      />

      <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
        No {title} exist
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 400,
          color: theme.nawy.colors.semantic.text.secondary,
          textAlign: "center",
        }}
      >
        There are currently no {title}
      </Typography>
    </Box>
  );
};

export default EmptySection;
